import { render, staticRenderFns } from "./PurchaseOrderView.vue?vue&type=template&id=3ce140a0&scoped=true&"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce140a0",
  null
  
)

export default component.exports